/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TWebGetUserFavoritesModel,
  IWebGetUserFavoritesRequest,
  IMappers,
  IWebGetUserFavoritesResponse,
  IWebGetUserFavoritesResponseError,
  TWebGetUserFavoritesResponse,
} from './types';

const defaultConfig: TWebGetUserFavoritesModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/web/get-user-favorites/',
  hostType: 'api',
} as TWebGetUserFavoritesModel;

function createWebGetUserFavoritesModel(parameters: IWebGetUserFavoritesRequest): TWebGetUserFavoritesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IWebGetUserFavoritesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IWebGetUserFavoritesRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchWebGetUserFavorites<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IWebGetUserFavoritesOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TWebGetUserFavoritesResponse
> {
  const { response, statusCode } = await httpApi.fetch(createWebGetUserFavoritesModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IWebGetUserFavoritesResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IWebGetUserFavoritesResponseError);
    }
  }

  return { response, statusCode } as TWebGetUserFavoritesResponse;
}

export { defaultConfig, createWebGetUserFavoritesModel, fetchWebGetUserFavorites };
